import { ChevronLeft, ChevronRight, Loader2, Search, X, AlertTriangle } from "lucide-react";

export function ViewerSearchBar({ query, setQuery, count, active, onPrev, onNext, indexing, noText }) {
  if (noText) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 text-xs text-amber-300 bg-amber-950/40 border-b border-amber-800" data-testid="pdf-no-text-warning">
        <AlertTriangle className="w-4 h-4 shrink-0" />Bu PDF'de aranabilir metin yok (taranmış/resim PDF).
      </div>
    );
  }
  const onKey = (e) => {
    if (e.key === "Enter") { e.preventDefault(); e.shiftKey ? onPrev() : onNext(); }
  };
  const hasQ = query.trim().length > 0;
  return (
    <div className="flex items-center gap-1.5 px-2 sm:px-3 py-2 border-b border-slate-800 bg-slate-900" data-testid="pdf-search-bar">
      <div className="relative flex-1 min-w-0">
        <Search className="w-4 h-4 absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400" />
        <input type="text" inputMode="search" enterKeyHint="search" value={query} onChange={(e) => setQuery(e.target.value)} onKeyDown={onKey}
          placeholder="Fiyat Listesinde Ara" autoComplete="off"
          className="w-full h-10 pl-8 pr-8 rounded-sm bg-slate-950 border border-slate-700 text-base sm:text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:border-orange-500"
          data-testid="pdf-search-input" />
        {hasQ && (
          <button onClick={() => setQuery("")} className="absolute right-1.5 top-1/2 -translate-y-1/2 p-1 text-slate-400 hover:text-white" data-testid="pdf-search-clear" aria-label="Temizle">
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
      <span className="text-xs font-mono text-slate-300 min-w-[54px] text-center whitespace-nowrap" data-testid="pdf-search-counter">
        {indexing ? <Loader2 className="w-4 h-4 animate-spin inline" /> : hasQ ? (count ? `${active + 1} / ${count}` : "0 sonuç") : ""}
      </span>
      <button onClick={onPrev} disabled={!count} className="h-10 w-10 sm:w-auto sm:px-2 inline-flex items-center justify-center rounded-sm border border-slate-700 text-slate-200 disabled:opacity-40 hover:bg-slate-800" data-testid="pdf-search-prev" aria-label="Önceki">
        <ChevronLeft className="w-4 h-4" /><span className="hidden sm:inline text-xs">Önceki</span>
      </button>
      <button onClick={onNext} disabled={!count} className="h-10 w-10 sm:w-auto sm:px-2 inline-flex items-center justify-center rounded-sm border border-slate-700 text-slate-200 disabled:opacity-40 hover:bg-slate-800" data-testid="pdf-search-next" aria-label="Sonraki">
        <span className="hidden sm:inline text-xs">Sonraki</span><ChevronRight className="w-4 h-4" />
      </button>
    </div>
  );
}
